'use client';

import * as React from 'react';
import { Auth } from '@/shared/i18n';
import { Link, Typography } from '@mui/material';

interface ResendConfirmationEmailProps {
  dict: Auth;
  handleResendEmail: () => void;
}

const ResendConfirmationEmail: React.FC<ResendConfirmationEmailProps> = ({
  dict,
  handleResendEmail,
}) => {
  const [isReSent, setIsReSent] = React.useState(false);
  return (
    <div className="flex flex-col items-center justify-center w-full gap-1 mt-8">
      <small className="font-medium text-gray-400 text-body2">
        {dict.register?.email_not_received || 'Non hai ricevuto niente? '}
      </small>
      <Typography
        onClick={() => {
          handleResendEmail();
          setIsReSent(true);
        }}
        variant="subtitle1"
        component="p"
        className="mb-8"
        color="primary"
      >
        <small>
          {isReSent
            ? `${dict.register?.resend_email_active || 'Nuova email inviata!'}`
            : `${dict.register?.resend_email || 'Reinvia la mail'}`}
        </small>
      </Typography>
    </div>
  );
};

export default ResendConfirmationEmail;
